import { RadioGroup, tk } from '@sunwebgroup/ui-components'

import { styled } from 'styled-components'

export const Column = styled(RadioGroup.Root)`
  padding: ${tk('spacing_md')};
  background-color: ${tk('color_semantic_bg_subdued')};
  outline: none;
  height: fit-content;
  flex-basis: 100%;
`
